import VisibleComponent from '../VisibleComponent'
import './index.less'

const template = `
     <div class="mtg-ad-logo">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAMAAAC7xnO3AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABdUExURUxpcfj4+vf7+/f4+fv///f5+fj4+fb5+vf3+Pj4+/////j5+vb5+fj4//f5+fn5+ff4+cXGx/P19cjJyvb3+NPU1c/R0aurrb6/weDh4uzt7s3Pz+fo6bW1tvDx8hJl0wsAAAAQdFJOUwCaReYch8XW8VAFbbMpr1qt57L9AAABs0lEQVR42p3X7a6DIAwG4G6C4M7Uoujm1+7/Mg8aWSNM5/r+hDxBsUkrfIwoZaESbXWiClkKOJlcKtxGyfyEy1L8lDT75hTuRR1Zccej3MUevGo8jr5+hn8Wv8X+QZzbBc/kcotgiueShvSCZ3MJ3hHPZ/OuV385vXl0Fcapukfd+2u6EhR6XRub2jS9jaDtW1M347qh6bv6Ahhb40KUYGNc2tGXhIfZujDv10QDWLtTX+uKL0Rfq43bHDtn24USHJzrxtoMna/h7ZH4cKaqPA1g9Rrcsbg5NEWSTYULHVZKECt3Sc93Pcwwx6101CyUoHFwKzF3UobSU5zjYSilkyqSaN+0r+dHtRhJBSAwlEQJRhIFlJEk2hGMZAkykkQJxlJCEUmiLh5GsgAVSaIEY6kgCSWlqzvEPZmA3pfY477UYA8kHkgLmik1JEyZgGJKBQVTFiCZUkLJlCUIphQAiiUVAEiWlE7mLJmDS8qQKczJGDKDJepnqaiv/Cgz6mW/yXvQP09LLcKe/Zwm89qVLzNNbdCzeXMCfzbhz0P8GYw/9/FnTf58y5+p+XM8/9+B/7/yD9Gip1Kigz+MAAAAAElFTkSuQmCC" alt="" class="mtg-logo">
        <span>${window.navigator.language.indexOf('zh') > -1 ? '广告' : 'AD'}</span>
     </div>
`

/**
 * Ad类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Ad extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.logoElem = this.element.querySelector('.mtg-logo')
        const {
            logo = true,
            type = "roundedRect",
            theme = "black",
            position = "rightBottom"
        } = options;
        if (logo === false) {
            this.element.removeChild(this.logoElem)
        }
        switch (type) {
            case "roundedRect":
                this.element.classList.add("mtg-ad-logo-rounded-rect")
                break;
            case "rightTopRect":
                this.element.classList.add("mtg-ad-logo-right-top-rect")
                break;
            case "leftTopRect":
                this.element.classList.add("mtg-ad-logo-left-top-rect")
                break;
            case "rightBottomRect":
                this.element.classList.add("mtg-ad-logo-right-bottom-rect")
                break;
            case "leftBottomRect":
                this.element.classList.add("mtg-ad-logo-left-bottom-rect")
                break;
            case "rightTopNoRect":
                this.element.classList.add("mtg-ad-logo-right-top-no-rect")
                break;
            case "antidiagonalRect":
                this.element.classList.add("mtg-ad-logo-antidiagonal-rect")
                break;
            case "diagonalRect":
                this.element.classList.add("mtg-ad-logo-diagonal-rect")
                break;
            default:
                this.element.classList.add("mtg-ad-logo-rounded-rect")
        }
        switch (theme) {
            case "black":
                this.element.classList.add("mtg-ad-logo-black")
                break;
            case "white":
                this.element.classList.add("mtg-ad-logo-white")
                break;
            default:
                this.element.classList.add("mtg-ad-logo-black")
        }
        switch (position) {
            case "leftTop":
                this.element.classList.add("mtg-ad-logo-left-top")
                break;
            case "rightTop":
                this.element.classList.add("mtg-ad-logo-right-top")
                break;
            case "leftBottom":
                this.element.classList.add("mtg-ad-logo-left-bottom")
                break;
            case "rightBottom":
                this.element.classList.add("mtg-ad-logo-right-bottom")
                break;
            default:
                this.element.classList.add("mtg-ad-logo-right-bottom")
        }
    }
}

export default Ad